import { Alert, Row, Col } from "react-bootstrap";

export const AlertMessage = (props) => {
  return (
      <div className="fixed-bottom bg-white border-top border-2 py-2 mt-3">          
          <Row className="justify-content-center">
            <Col xs={11} md={10} className="d-flex justify-content-center text-center">
              <Alert 
                variant="secondary"
                onClose={() => props.setAlertMessage(false)}
                dismissible
                className="w-100"
              >
                {props.alertMessage}
              </Alert>
            </Col>
          </Row>
        </div>
  );
};
